import Script from "next/script";
import { Dialog, DialogProps } from "@netfront/ui-library";
import { ParentWelcomeVideo } from "@/components";

export interface WelcomeVideoDialogProps extends Pick<DialogProps, 'isOpen' | 'onClose'> {};

export const WelcomeVideoDialog = ({ isOpen, onClose }: WelcomeVideoDialogProps) => {
  return(
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Welcome"
    >
      <ParentWelcomeVideo />
    </Dialog>
  )
};